import { AxiosInstance } from "axios";
import { Partner } from "../models/partner";

const PARTNERS_API_PREFIX = "/partners";

export async function getPartners(http: AxiosInstance): Promise<Partner[]> {
	const response = await http.get(PARTNERS_API_PREFIX + "/partners/active");
	return response.data;
}
